import {
  changeAutoSyncAction,
  setAutoPauseAction,
  setHoverAutoPauseAction, setPauseOnNoteAction,
  setShowNativeCaptionsAction, setShowTranslationsAction, updateGeneralAction
} from '../store/general/actions';
import { getDispatch } from '../store';
import { UserRest } from '../../common/rest/user/userRest';

export class UserSettingEffects {

  public static async setAutoPause(pause: number) {
    const dispatch = getDispatch();
    dispatch(setAutoPauseAction(pause));
    await UserRest.saveSettings({pause});
  }

  public static async setHoverAutoPause(hoverAutoPause: boolean) {
    const dispatch = getDispatch();
    dispatch(setHoverAutoPauseAction(hoverAutoPause));
    await UserRest.saveSettings({hoverAutoPause});
  }

  public static async setAutoSync(autoSync: boolean) {
    const dispatch = getDispatch();
    dispatch(changeAutoSyncAction(autoSync));
    await UserRest.saveSettings({autoSync});
  }

  public static async setShowNativeCaptions(show: boolean) {
    const dispatch = getDispatch();
    dispatch(setShowNativeCaptionsAction(show));
    await UserRest.saveSettings({showNativeCaptions: show});
  }

  public static async setPauseOnNote(value: boolean) {
    const dispatch = getDispatch();
    dispatch(setPauseOnNoteAction(value));
    await UserRest.saveSettings({pauseOnNote: value});
  }

  public static async setShowTranslations(value: boolean) {
    const dispatch = getDispatch();
    dispatch(setShowTranslationsAction(value));
    await UserRest.saveSettings({showTranslations: value});
  }

  public static async setAutoSpeechRate(value: number) {
    const dispatch = getDispatch();
    dispatch(updateGeneralAction({autoSpeechRate: value}));
    await UserRest.saveSettings({autoSpeechRate: value});
  }

}
